import { sql } from 'kysely';

import { db } from ':fat/database/kysely';
import { DatabaseWorker } from ':fat/messaging/entities/databaseWorker';

export async function sanityCheck() {
  // TODO: Check that all browser dependencies we'll need are present and that
  // everything was loaded successfully

  try {
    const result = await DatabaseWorker.actions.query(
      db.selectNoFrom([sql`'from main page'`.as('sanity_value')]).compile(),
    );
    if (result[0].sanity_value !== 'from main page') {
      return { success: false, errorMessage: 'Query did not return expected result' };
    }
  } catch (error: unknown) {
    if (error instanceof Error) {
      return { success: false, errorMessage: `Query was not successful: ${error.message}` };
    }
  }

  return { success: true };
}
